import { render, staticRenderFns } from "./SuperkidLanding.vue?vue&type=template&id=7fb40d4f&scoped=true&"
import script from "./SuperkidLanding.vue?vue&type=script&lang=js&"
export * from "./SuperkidLanding.vue?vue&type=script&lang=js&"
import style0 from "./SuperkidLanding.vue?vue&type=style&index=0&id=7fb40d4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb40d4f",
  null
  
)

export default component.exports